module.exports = __webpack_public_path__ + "img/sport-default-header.b838f477.png";